import { ReactNode, createContext, useMemo } from 'react';
import useAuth from '~/hooks/useAuth';
import { Permissions } from '../@types/user';

const initialState: Permissions = {
  role: {
    toChange: false,
  },
  user: {
    privateLists: {
      toRead: false,
    },
    toMasquarade: false,
  },
};

const PermissionContext = createContext(initialState);

type PermissionProviderProps = {
  children: ReactNode;
};

function PermissionProvider({ children }: PermissionProviderProps) {
  const { user } = useAuth();
  const role = user?.attributes?.role;

  const isManager = role === 'manager';

  const isAllowed = useMemo(
    () => ({
      role: {
        toChange: isManager,
      },
      user: {
        privateLists: {
          toRead: isManager,
        },
        toMasquarade: isManager,
      },
    }),
    [isManager]
  );

  return <PermissionContext.Provider value={isAllowed}>{children}</PermissionContext.Provider>;
}

export { PermissionProvider, PermissionContext };
